class ShopByFabricJumplinks extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      const link = e.target.closest('a');

      if (!link) return;

      const target = document.querySelector(link.getAttribute('href'));

      if (!target) return;

      e.preventDefault();

      window.scroll({ top: target.offsetTop - 120, behavior: 'smooth' });

      this.dispatchEvent(new CustomEvent('markup-modal:close', { bubbles: true, detail: { focusOnClose: target } }));
    });
  }

  connectedCallback() {
  }

  disconnectedCallback() {

  }
}

if (!customElements.get("shop-by-fabric-jumplinks")) {
  customElements.define("shop-by-fabric-jumplinks", ShopByFabricJumplinks);
}
